import _slicedToArray from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-a4eb0c7a"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "applist"
};
var _hoisted_2 = {
  key: 0,
  class: "list"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "title"
  }, "请选择要进入的产品", -1);
});

var _hoisted_4 = ["onClick"];
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import CompanyService from '@/api/company';
import { ElMessage } from 'element-plus';
import { companyDetailTip } from '@/config/company';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    var appList = ref([]);
    var isLoading = ref(true);
    var corporationId = ref('');
    var isPrivateEnv = window.AppConfig.isPrivateEnv; // todo: 新版tob需要改造demo企业，当前版本不改造

    var goDemoIndustry = function goDemoIndustry(id) {
      if (window.__MICRO_APP_ENVIRONMENT__) {
        var _window, _window$microApp, _globalAPI$router;

        var _window$microApp$getD = (_window = window) === null || _window === void 0 ? void 0 : (_window$microApp = _window.microApp) === null || _window$microApp === void 0 ? void 0 : _window$microApp.getData(),
            globalAPI = _window$microApp$getD.globalAPI;

        globalAPI === null || globalAPI === void 0 ? void 0 : (_globalAPI$router = globalAPI.router) === null || _globalAPI$router === void 0 ? void 0 : _globalAPI$router.subAppPush('console', '/');
      } else {
        router.push("/console?corp_id=".concat(id));
      }
    };

    var entryApp = function entryApp(curApp) {
      var _window$AppConfig$spa;

      if ((_window$AppConfig$spa = window.AppConfig.space) !== null && _window$AppConfig$spa !== void 0 && _window$AppConfig$spa.entryBeacon) {
        window.open(curApp.app_link, '_blank');
      } else {
        router.push("/spacelist?corp_id=".concat(corporationId.value, "&app_key=").concat(curApp.app_key));
      }
    }; // 获取企业列表


    var getCompanyList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var passedData, _passedData$data$resu, passedCompanyList, _passedCompanyList$;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return CompanyService.getCompanyList();

              case 2:
                passedData = _context.sent;

                if (passedData.data.code === 1) {
                  passedCompanyList = (_passedData$data$resu = passedData.data.result) === null || _passedData$data$resu === void 0 ? void 0 : _passedData$data$resu.filter(function (item) {
                    return item.corporation_id !== 'demo';
                  });

                  if (passedCompanyList !== null && passedCompanyList !== void 0 && passedCompanyList.length) {
                    corporationId.value = (_passedCompanyList$ = passedCompanyList[0]) === null || _passedCompanyList$ === void 0 ? void 0 : _passedCompanyList$.corporation_id;
                  }
                } else {
                  ElMessage({
                    message: companyDetailTip.error,
                    type: 'error'
                  });
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getCompanyList() {
        return _ref.apply(this, arguments);
      };
    }();

    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _companyData$data, _appData$data;

      var _route$query, _route$query$corp_id, corp_id, _route$query$app_key, app_key, result, _result, companyData, appData, _companyData$data$res, _appList$value, appKeys, totalList, currentApp, msgText, appKey;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _route$query = route.query, _route$query$corp_id = _route$query.corp_id, corp_id = _route$query$corp_id === void 0 ? '' : _route$query$corp_id, _route$query$app_key = _route$query.app_key, app_key = _route$query$app_key === void 0 ? '' : _route$query$app_key;
              corporationId.value = (corp_id === null || corp_id === void 0 ? void 0 : corp_id.toString()) || ''; // 私有化环境下，首页即产品选择页，此时只有唯一企业，默认显示该企业下的产品列表

              if (!isPrivateEnv) {
                _context2.next = 5;
                break;
              }

              _context2.next = 5;
              return getCompanyList();

            case 5:
              _context2.next = 7;
              return Promise.all([CompanyService.getCompanyInfo({
                corporation_id: corporationId.value
              }), CompanyService.getPlatformList({
                corporationId: corporationId.value
              })]);

            case 7:
              result = _context2.sent;
              _result = _slicedToArray(result, 2), companyData = _result[0], appData = _result[1];

              if (!(((_companyData$data = companyData.data) === null || _companyData$data === void 0 ? void 0 : _companyData$data.code) === 1 && ((_appData$data = appData.data) === null || _appData$data === void 0 ? void 0 : _appData$data.code) === 1)) {
                _context2.next = 23;
                break;
              }

              appKeys = ((_companyData$data$res = companyData.data.result) === null || _companyData$data$res === void 0 ? void 0 : _companyData$data$res.app_keys) || [];
              totalList = appData.data.result;

              if (appKeys.length) {
                _context2.next = 14;
                break;
              }

              return _context2.abrupt("return", ElMessage({
                message: '您的企业未开通产品，请联系管理员',
                type: 'error'
              }));

            case 14:
              appList.value = appKeys.map(function (item) {
                return totalList.filter(function (app) {
                  return app.app_key === item;
                })[0];
              }).filter(function (item) {
                return item === null || item === void 0 ? void 0 : item.app_key;
              }); // 业务没有开通当前产品

              if (!(app_key && !appKeys.includes(app_key))) {
                _context2.next = 20;
                break;
              }

              isLoading.value = false;
              currentApp = totalList.find(function (item) {
                return item.app_key === app_key;
              });
              msgText = currentApp ? "\u60A8\u7684\u4F01\u4E1A\u672A\u5F00\u901A\u5F53\u524D\u4EA7\u54C1".concat(currentApp.app_name, "\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458") : "\u60A8\u8F93\u5165\u7684\u7684\u4EA7\u54C1\u53C2\u6570".concat(app_key, "\u6709\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u8F93\u5165");
              return _context2.abrupt("return", ElMessage({
                message: msgText,
                type: 'error'
              }));

            case 20:
              // 只有唯一的产品，直接跳过
              if (((_appList$value = appList.value) === null || _appList$value === void 0 ? void 0 : _appList$value.length) === 1) {
                appKey = appList.value[0].app_key;
                router.push("/spacelist?corp_id=".concat(corporationId.value, "&app_key=").concat(appKey));
              }

              _context2.next = 24;
              break;

            case 23:
              ElMessage({
                message: '获取企业应用列表失败',
                type: 'error'
              });

            case 24:
              isLoading.value = false;

            case 25:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!isLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appList.value, function (item) {
        return _openBlock(), _createElementBlock("li", {
          key: item.app_key
        }, [_createElementVNode("a", {
          onClick: function onClick($event) {
            return entryApp(item);
          }
        }, _toDisplayString(item.app_name), 9, _hoisted_4)]);
      }), 128))])])) : _createCommentVNode("", true)]);
    };
  }
});